import { remoteConfig } from "../../firebase";
import {
  FETCH_REMOTE_CONFIG_REQUEST,
  FETCH_REMOTE_CONFIG_SUCCESS,
  FETCH_REMOTE_CONFIG_FAILURE,
} from "./RemoteConfig";

export const fetchRemoteConfigRequest = () => ({
  type: FETCH_REMOTE_CONFIG_REQUEST,
});

export const fetchRemoteConfigSuccess = (config) => ({
  type: FETCH_REMOTE_CONFIG_SUCCESS,
  payload: config,
});

export const fetchRemoteConfigFailure = (error) => ({
  type: FETCH_REMOTE_CONFIG_FAILURE,
  payload: error,
});

export const fetchAndActivateConfig = () => {
  console.log("dispatching fetchRemoteConfigRequest()");
  return (dispatch) => {
    dispatch(fetchRemoteConfigRequest());
    console.log("calling fetchAndActivate()");
    remoteConfig
      .fetchAndActivate()
      .then(() => {
        console.log("fetch and activate success");
        const configValues = remoteConfig.getAll();
        dispatch(fetchRemoteConfigSuccess(configValues));
      })
      .catch((error) => {
        console.log("fetch and activate failed: " + error);
        dispatch(fetchRemoteConfigFailure(error));
      });
  };
};
